import React, { useEffect, useState } from "react";
import client from "../api/client";

export default function LoginActivity() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await client.get("/login-activity");
      console.log(res.data);
setRows(res.data || []);    } catch (err) {
      console.error("Login activity error", err);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ fontWeight: 900 }}>Login Activity</h2>

      <div className="attendance-card" style={{ marginTop: 14 }}>
        <table className="attendance-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Date</th>
              <th>Time</th>
              <th>Device</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No history yet
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.employee_name || r.employee_id}</td>
                  <td>{new Date(r.login_at).toLocaleDateString()}</td>
                  <td>{new Date(r.login_at).toLocaleTimeString()}</td>
                  <td>{r.device}</td>
                  <td>{r.status}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
